/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Dark_ModeInputs */



/**
* | output |
* | --- |
* | "Dark mode" |
*
* @param {Layout_Header_Dark_ModeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_dark_mode = /** @type {((inputs?: Layout_Header_Dark_ModeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Dark_ModeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dunkler Modus")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode sombre")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("深色模式")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("深色模式")
	if (locale === "ko") return /** @type {LocalizedString} */ ("다크 모드")
	return /** @type {LocalizedString} */ ("Dark mode")
});